import React, { useState, useEffect } from 'react';
import { Assignment, Close, Edit, IntegrationInstructions, Update } from '@mui/icons-material';
import RiparazioniDOAEditModal from './components/modal/RiparazioniDOAEditModal';
import MerceNonConformeEditModal from './components/modal/MerceNonConformeEditModal';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Typography,
    TextField,
    Button,
    Skeleton,
    Snackbar,
    Alert,
    Popover,
    Box,
    MenuItem,
} from '@mui/material';
import CustomDatePickerFilter from './components/fields/CustomDatePickerFilter';
import dayjs from 'dayjs';
import SendAvviso from './components/SendAvviso';
import SendEmail from './components/SendEmail';
import RichiestaIntegrazioneModal from './components/modal/RichiestaIntegrazioneModal';
import ApiService from './components/service/ApiService';


const TabellaDashboardSAT = ({ updateCard }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [anchorEl,                        setAnchorEl                         ] = useState(null);
    const [rowOptions,                      setRowOptions                       ] = useState(null);  

    const [openSnackbar,                    setOpenSnackbar                     ] = useState(false);
    const [message,                         setMessage                          ] = useState('');
    const [snackbarSeverity,                setSnackbarSeverity                 ] = useState('success');
    const [filtriAttivi,                    setFiltriAttivi                     ] = useState(false);
    const [isModalOpen,                     setIsModalOpen                      ] = useState(false);
    const [isModalDOAOpen,                  setIsModalDOAOpen                   ] = useState(false);
    const [isModalDanneggiataOpen,          setIsModalDanneggiataOpen           ] = useState(false);
    const [isModalNonConformeOpen,          setIsModalNonConformeOpen           ] = useState(false);
    const [isModalIntegrazioneOpen,         setIsModalIntegrazioneOpen          ] = useState(false);
    const [selectedRMA,                     setSelectedRMA                      ] = useState(null);
    const [datiRMA,                         setDatiRMA                          ] = useState([]);
    const [loading,                         setLoading                          ] = useState(true);
    const [filtri,                          setFiltri                           ] = useState({
        idReso: '',
        numeroFattura: '',
        data: '',
        stato: '',
        descrizione: ''
    });    

    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;

    const headers = {
        Authorization: `Bearer ${token}`,
    };

    const fetchDatiRMA = async () => {
        setLoading(true);
        try {
            // const responseRMA = await axios.get('http://localhost:8080/rma', { headers: headers });
            const responseRMA = await ApiService.request("getRma");

        if (responseRMA.data && Array.isArray(responseRMA.data.rma)) {
            const datiOrdinati = responseRMA.data.rma.sort((a, b) => {
                const dataA = dayjs(a.dataFattura || a.dataRicezioneMerce);
                const dataB = dayjs(b.dataFattura || b.dataRicezioneMerce);
                return dataB.diff(dataA); 
            });
            setDatiRMA(datiOrdinati);
        } else {
                console.error("I dati RMA non sono nel formato Array:", responseRMA.data);
            }
        } catch (error) {
            console.error("Errore nel recupero dei dati RMA", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDatiRMA();
    }, []);

    const handleOpenOptions = (event, row) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setRowOptions(row);
    };

    const handleCloseOptions = () => {
        setAnchorEl(null);
        setRowOptions(null);
    };


    const handleEditRMA = (row) => {
        setSelectedRMA(row);
        switch (row.tipologia) {
            case 'RIPARAZIONE':
            case 'DOA':
                setIsModalDOAOpen(true);
                break;
            case 'ANOMALIA_MERCE_DANNEGGIATA':
                setIsModalDanneggiataOpen(true);
                break;
            case 'ANOMALIA_MERCE_NON_CONFORME':
                setIsModalNonConformeOpen(true);
                break;
            default:
                console.error("Tipologia non gestita:", row.tipologia);
        }
        handleCloseOptions();
    };
    

    const handleOpenRichiestaintegrazione = (row) => {
        setSelectedRMA(row);
        setIsModalIntegrazioneOpen(true);
        handleCloseOptions();
    };

    const handleAssegnaRMA = (row) => {
        handleCloseOptions();
    };

    const openPopover = Boolean(anchorEl);

    const handleInputChange = (field, value) => {
        setFiltri((prevFiltri) => ({
            ...prevFiltri,
            [field]: value,
        }));
    };

    const handleToggleFiltri = () => {
        setFiltriAttivi(!filtriAttivi);

        if (filtriAttivi) {
            setFiltri({
                idReso: '',
                numeroFattura: '',
                data: '',
                stato: '',
                descrizione: ''
            });
        }
    };

    const handleSave = (updatedData) => {
        setIsModalOpen(false);
        fetchDatiRMA();
        updateCard()
    };

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    const handleContattaCliente = (row) => {
        const idReso = row.idReso;
        const destinatario = row.cliente?.emailPersonaContatto;
        const idDestinatario = row.cliente?.id;   

        const messaggio = null;
    
        
        /* invio email */
        // SendEmail(
        //     idReso,
        //     destinatario,
        //     messaggio,
        //     'CONTATTA_CLIENTE',
        //     () => {
        //         setMessage(t('Email di contatto inviata con successo!'));
        //         setSnackbarSeverity('success');
        //         setOpenSnackbar(true);
        //     },
        //     () => {
        //         setMessage(t("Errore nell'invio dell'email. Per favore, riprova."));
        //         setSnackbarSeverity('error');
        //         setOpenSnackbar(true);
        //     }
        // );

        // Invio avviso
        // SendAvviso(
        //     idReso,
        //     idDestinatario,
        //     'AVVISO_SAT',

        //     () => {
        //         setMessage(t('Avviso inviato al cliente con successo!'));
        //         setSnackbarSeverity('success');
        //         setOpenSnackbar(true);
        //     },
        //     () => {
        //         setMessage(t("Errore nell'invio dell'avviso. Per favore, riprova."));
        //         setSnackbarSeverity('error');
        //         setOpenSnackbar(true);
        //     }
        // );

        navigate('/chat',
            {
                state:
                {
                    contact:
                    {
                        idCliente: row?.cliente?.id,
                        idReso: row?.idReso,
                        ragioneSociale: row?.cliente?.ragioneSociale,
                        email: row?.cliente?.emailPersonaContatto,
                        ultimoMessaggio: null
                    }
                }
            }
        );
    };

    const getTipologiaColor = (tipologia) => {
        switch (tipologia) {
            case 'RIPARAZIONE':
                return '#263F78';
            case 'DOA':
                return '#FDA03D';
            case 'ANOMALIA_MERCE_DANNEGGIATA':
                return '#32976b';
            case 'ANOMALIA_MERCE_NON_CONFORME':
                return '#952828';
            default:
                return 'grey';
        }
    }

    const getStatoColor = (stato) => {
        switch (stato) {
            case 'IN_ATTESA':
                return 'gray';
            case 'IN_LAVORAZIONE':
                return 'blue';
            case 'ACCETTATO_INVIO_CLIENTE':
                return 'lightgreen';
            case 'ACCETTATO_ATTESA_INFO_RITIRO':
                return 'darkgreen';
            case 'ACCETTATO':
                return 'green';
            case 'RIFIUTATO':
                return 'red';
            case 'RINVIATO':
                return 'orange';
            case 'RIMBORSATO':
                return 'purple';
            default:
                return 'black';
        }
    };

    const filteredData = datiRMA.filter((row) => {

        const matchId = !filtri.id || row.id?.toString().includes(filtri.id);
        const matchTipologia = !filtri.tipologia || row.tipologia?.toLowerCase().replace(/_/g, ' ').includes(filtri.tipologia.toLowerCase());
        const matchData =
            !filtri.data ||
            (dayjs(row.dataFattura).isSame(dayjs(filtri.data))) ||
            (dayjs(row.dataRicezioneMerce).isSame(dayjs(filtri.data)));
        const matchIdReso = !filtri.idReso || row.idReso?.toString().includes(filtri.idReso);
        const formattedStato = !filtri.stato || row.stato?.toLowerCase().replace(/_/g, ' ').includes(filtri.stato);
        /* const matchCliente = !filtri.cliente || row.cliente?.toLowerCase().includes(filtri.cliente.toLowerCase()); */
        const matchNumeroFattura = !filtri.numeroFattura || row.numeroFattura?.toString().startsWith(filtri.numeroFattura);
        const matchOperatore = !filtri.operatore || row.operatore?.toLowerCase().includes(filtri.operatore.toLowerCase());
        const matchCommerciale = !filtri.cliente?.commerciale[0] || row.cliente?.commerciale[0]?.toLowerCase().includes(filtri.cliente?.commerciale[0].toLowerCase());

        return (
            matchId &&
            matchTipologia &&
            matchIdReso &&
            formattedStato &&
            matchNumeroFattura &&
            matchData &&
            /* matchCliente && */
            matchOperatore &&
            matchCommerciale
        );
    });

    return (
        <>
            <TableContainer
                sx={{
                    borderRadius: '20px',
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    ml: 2,
                    mr: 2,
                    mb: 2,
                    mt: { xs: 2, md: 0 },
                    width: 'auto',
                    height: '58vh',
                    overflowY: 'auto',
                    border: '1px solid #cccccc',
                    background: 'linear-gradient(145deg, #fefefe, #f5f5f5)',
                    // borderBottom: '4px solid #FDA03D',
                    // borderLeft: '4px solid #FDA03D',
                    '&::-webkit-scrollbar': {
                        display: 'none', // Chrome, Safari, Opera
                    },
                    'msOverflowStyle:': 'none',  // IE e Edge
                    'scrollbarWidth': 'none',  // Firefox
                }}
            >
                <Table>
                    <TableHead
                        sx={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1000,
                            background: 'linear-gradient(145deg, #fefefe, #f5f5f5)',
                        }}
                    >
                        <TableRow>
                            {/* <TableCell>
                                {filtriAttivi ? (
                                    <TextField
                                        variant='standard'
                                        placeholder="ID Richiesta"
                                        size="small"
                                        value={filtri.id}
                                        onChange={(e) => handleInputChange('id', e.target.value)}
                                        sx={{
                                            "& .MuiInput-input": {
                                                padding: "16px 0px",
                                            },
                                            "& .MuiInput-underline:before": {
                                                borderBottom: "1px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottom: "2px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottom: "2px solid #fda03d",
                                            }
                                        }}
                                    />
                                ) : (
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#FDA03D' }}>ID Richiesta</Typography>
                                )}
                            </TableCell> */}
                            <TableCell>
                                {filtriAttivi ? (
                                    <TextField
                                        variant='standard'
                                        placeholder="ID Reso"
                                        size="small"
                                        value={filtri.idReso}
                                        onChange={(e) => handleInputChange('idReso', e.target.value)}
                                        sx={{
                                            "& .MuiInput-input": {
                                                padding: "16px 0px",
                                            },
                                            "& .MuiInput-underline:before": {
                                                borderBottom: "1px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottom: "2px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottom: "2px solid #fda03d",
                                            }
                                        }}
                                    />
                                ) : (
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#FDA03D' }}>
                                        {t('ID Reso')}
                                    </Typography>
                                )}
                            </TableCell>

                            <TableCell>
                                {filtriAttivi ? (
                                    <TextField
                                        variant="standard"
                                        placeholder="N. Fattura"
                                        size="small"
                                        value={filtri.numeroFattura}
                                        onChange={(e) => handleInputChange('numeroFattura', e.target.value)}
                                        sx={{
                                            "& .MuiInput-input": {
                                                padding: "16px 0px",
                                            },
                                            "& .MuiInput-underline:before": {
                                                borderBottom: "1px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottom: "2px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottom: "2px solid #fda03d",
                                            }
                                        }}
                                    />
                                ) : (
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#FDA03D' }}>
                                        {t('N. Fattura')}
                                    </Typography>
                                )}
                            </TableCell>


                            <TableCell>
                                {filtriAttivi ? (
                                    <TextField
                                        variant='standard'
                                        placeholder="Tipo Richiesta"
                                        size={"small"}
                                        value={filtri.tipologia}
                                        onChange={(e) => handleInputChange('tipologia', e.target.value)}
                                        sx={{
                                            "& .MuiInput-input": {
                                                padding: "16px 0px",
                                            },
                                            "& .MuiInput-underline:before": {
                                                borderBottom: "1px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottom: "2px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottom: "2px solid #fda03d",
                                            }
                                        }}
                                    />
                                ) : (
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#FDA03D' }}>
                                        {t('Tipo Richiesta')}
                                    </Typography>
                                )}
                            </TableCell>
                            <TableCell>
                                {filtriAttivi ? (
                                    <CustomDatePickerFilter
                                        name="data"
                                        onDateChange={(value) => handleInputChange("data", value)}
                                        values={filtri.data}
                                        minDate="2020/01/01"
                                    />
                                ) : (
                                    <Typography variant="body2" sx={{ fontWeight: "bold", color: "#FDA03D" }}>
                                        {t('Data')}
                                    </Typography>

                                )}
                            </TableCell>

                            <TableCell>
                                {filtriAttivi ? (
                                    <TextField
                                        variant='standard'
                                        placeholder="Stato"
                                        size="small"
                                        value={filtri.stato}
                                        onChange={(e) => handleInputChange('stato', e.target.value)}
                                        sx={{
                                            "& .MuiInput-input": {
                                                padding: "16px 0px",
                                            },
                                            "& .MuiInput-underline:before": {
                                                borderBottom: "1px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottom: "2px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottom: "2px solid #fda03d",
                                            }
                                        }}
                                    />
                                ) : (
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#FDA03D' }}>
                                        {t('Stato')}
                                    </Typography>
                                )}
                            </TableCell>

                            <TableCell>
                                {filtriAttivi ? (
                                    <TextField
                                        variant='standard'
                                        placeholder="Cliente"
                                        size="small"
                                        value={filtri.cliente}
                                        onChange={(e) => handleInputChange('cliente', e.target.value)}
                                        sx={{
                                            "& .MuiInput-input": {
                                                padding: "16px 0px",
                                            },
                                            "& .MuiInput-underline:before": {
                                                borderBottom: "1px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottom: "2px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottom: "2px solid #fda03d",
                                            }
                                        }}
                                    />
                                ) : (
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#FDA03D' }}>
                                        {t('Cliente')}
                                    </Typography>
                                )}
                            </TableCell>

                            {/* <TableCell>
                                {filtriAttivi ? (
                                    <TextField
                                        variant='standard'
                                        placeholder="Operatore"
                                        size="small"
                                        value={filtri.operatore}
                                        onChange={(e) => handleInputChange('operatore', e.target.value)}
                                    />
                                ) : (
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#FDA03D' }}>Operatore</Typography>
                                )}
                            </TableCell> */}

                            <TableCell>
                                {filtriAttivi ? (
                                    <TextField
                                        variant='standard'
                                        placeholder="Commerciale"
                                        size="small"
                                        value={filtri.commerciale}
                                        onChange={(e) => handleInputChange('commerciale', e.target.value)}
                                        sx={{
                                            "& .MuiInput-input": {
                                                padding: "16px 0px",
                                            },
                                            "& .MuiInput-underline:before": {
                                                borderBottom: "1px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottom: "2px solid #fda03d",
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottom: "2px solid #fda03d",
                                            }
                                        }}
                                    />
                                ) : (
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#FDA03D' }}>
                                        {t('Commerciale')}
                                    </Typography>
                                )}
                            </TableCell>

                            <TableCell>
                                <Button
                                    onClick={handleToggleFiltri}
                                    sx={{
                                        width: '100%',
                                        borderRadius: '10px',
                                        bgcolor: '#FDA03D',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        height: '30px',
                                        '&:hover': {
                                            bgcolor: '#FDA03D',
                                            color: 'white',
                                            transform: 'scale(1.02)'
                                        }
                                    }}>
                                    {filtriAttivi ? <Close sx={{ minWidth: 0, px: 5 }} /> : t('Filtra')}
                                </Button>
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {loading ? (
                            Array.from(new Array(5)).map((_, index) => (
                                <TableRow key={index}>
                                    <TableCell><Skeleton variant="text" /></TableCell>
                                    <TableCell><Skeleton variant="text" /></TableCell>
                                    <TableCell><Skeleton variant="text" /></TableCell>
                                    <TableCell><Skeleton variant="text" /></TableCell>
                                    <TableCell><Skeleton variant="text" /></TableCell>
                                    <TableCell><Skeleton variant="rectangular" width={100} height={40} /></TableCell>
                                    <TableCell><Skeleton variant="text" /></TableCell>
                                </TableRow>
                            ))
                        ) : filteredData.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={10}>
                                    <Typography variant="h6" align="center" fontSize={15}>
                                    {t('Non hai resi da visualizzare')}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            filteredData.map((row) => (
                                <React.Fragment key={row.id}>
                                    <TableRow 
                                    onClick={() => {
                                        if (row.tipologia === 'RIPARAZIONE' || row.tipologia === 'DOA') {
                                            handleEditRMA(row);
                                        }
                                    }}
                                    sx={{
                                        '&:hover': {
                                            backgroundColor: '#f5f5f5',
                                            cursor: 'pointer',
                                            transform: 'scale(1.01)',
                                            transition: 'transform 0.3s ease-in-out',
                                        }
                                    }}>
                                        {/* <TableCell sx={{ fontWeight: 'bold', color: 'grey' }}>{row.id}</TableCell> */}
                                        <TableCell sx={{ fontWeight: 'bold', color: 'grey' }}>{row.idReso}</TableCell>

                                        <TableCell sx={{ flex: 0.5, fontWeight: 'bold', color: 'grey' }}>
                                            {row?.numeroFattura}
                                        </TableCell>


                                        <TableCell sx={{
                                            width: '8em',
                                            fontWeight: 'bold',
                                            color: getTipologiaColor(row.tipologia),
                                            wordBreak: 'break-word',
                                        }}>
                                            {/* {row?.tipologia.replace(/_/g, ' ')} */}
                                            {t(`${row?.tipologia}`)}

                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 'bold', color: 'grey', flex: 1 }}>
                                            {row?.dataFattura ? row?.dataFattura : row?.dataRicezioneMerce}
                                        </TableCell>


                                        <TableCell sx={{ flex: 0.5 }}>
                                            {/* <span style={{ color: getStatoColor(row.stato), fontWeight: 'bold' }}>
                                                {row?.stato.replace(/_/g, ' ')}
                                            </span> */}
                                            <span style={{ color: getStatoColor(row.stato), fontWeight: 'bold' }}>
                                            {t(`${row?.stato}`)}
                                            </span>

                                        </TableCell>

                                        <TableCell sx={{ flex: 1 }}>
                                            <Button
                                                onClick={() => handleContattaCliente(row)}
                                                variant="outlined"
                                                size="small"
                                                sx={{
                                                    border: '1px solid #28334B',
                                                    color: '#28334B',
                                                    fontWeight: 'bold',
                                                    borderRadius: '40px',
                                                    '&:hover': {
                                                        bgcolor: '#28334B',
                                                        color: 'white',
                                                        transform: 'scale(1.02)',
                                                    },
                                                }}
                                            >
                                                {t('Contatta')} {row.cliente?.ragioneSociale || 'Cliente'}

                                            </Button>
                                        </TableCell>


                                        {/* <TableCell sx={{ fontWeight: 'bold', color: 'grey' }}>{row.operatore}</TableCell> */}

                                        <TableCell sx={{ fontWeight: 'bold', color: 'grey' }}>
                                            {row?.cliente?.commerciale
                                                ? `${row?.cliente?.commerciale?.nome} ${row?.cliente?.commerciale?.cognome}`
                                                : 'N/A'}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center', p: 0, flex: 0.5 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                                                <IconButton onClick={(event) => handleOpenOptions(event, row)}>
                                                    <MoreHorizIcon />
                                                </IconButton>


                                                {/* <Tooltip title="richiesta integrazione dati">
                                                    <IconButton onClick={() => handleOpenRichiestaintegrazione(row)} >
                                                        <SendIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Modifica">
                                                    <IconButton onClick={() => handleEditRMA(row)}>
                                                        <Edit />
                                                    </IconButton>
                                                </Tooltip> */}

                                            </Box>
                                        </TableCell>


                                    </TableRow>
                                </React.Fragment>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

             {/* Popover per opzioni */}
            <Popover
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handleCloseOptions}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                    {/* <MenuItem onClick={() => handleEditRMA(rowOptions)}>
                        <Update sx={{ mr: 1, color: '#FDA03D' }} />
                        <Typography sx={{ color: '#808080'}}> {t('Aggiorna RMA')}</Typography>
                    </MenuItem> */}
                    <MenuItem onClick={() => handleOpenRichiestaintegrazione(rowOptions)}>
                        <IntegrationInstructions sx={{ mr: 1, color: '#FDA03D' }} />
                        <Typography sx={{ color: '#808080'}}>{t('Richiesta integrazione RMA')}</Typography>
                    </MenuItem>
                </Box>
            </Popover>

            <>
                {isModalDOAOpen && (
                    <RiparazioniDOAEditModal
                        open={isModalDOAOpen}
                        onClose={() => setIsModalDOAOpen(false)}
                        selectedRMA={selectedRMA}
                        handleSave={handleSave}
                    />
                )}

                {isModalDanneggiataOpen && (
                    <MerceNonConformeEditModal
                        open={isModalDanneggiataOpen}
                        onClose={() => setIsModalDanneggiataOpen(false)}
                        selectedRMA={selectedRMA}
                        handleSave={handleSave}
                    />
                )}

                {isModalNonConformeOpen && (
                    <MerceNonConformeEditModal
                        open={isModalNonConformeOpen}
                        onClose={() => setIsModalNonConformeOpen(false)}
                        selectedRMA={selectedRMA}
                        handleSave={handleSave}
                    />
                )}
            </>


            <RichiestaIntegrazioneModal
                open={isModalIntegrazioneOpen}
                onClose={() => setIsModalIntegrazioneOpen(false)}
                selectedRMA={selectedRMA}
            />


            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default TabellaDashboardSAT;
